import { render } from "mithril"
import { useShadow, useShadowStyle } from "../wcUtil.ts"
import styleText from './shared-modal-styles.css?raw';

export class AsModalHomeWarning extends HTMLElement{
  get html(){
    return  /*html*/`
        <div id="warning-panel" class="panel-content warning">
          <as-text> </as-text>
          <as-text dict-key="apps.general.may-lose-changes">You are about to exit with unsaved changes. Your progress will be lost. 
          </as-text>
          <as-text dict-key="apps.general.continue-confirmation" class="center">Do you want to continue?
          </as-text>
          <div class="row option-buttons">
            <as-text-button name="cancel-exit-app">Cancel</as-text-button>
            <as-text-button name="confirm-exit-app">OK</as-text-button>
          </div>
        </div>
    `
  }
  connectedCallback(){
    useShadow(this,this.html)
    useShadowStyle(this,styleText,'./shared-modal-styles.css')
  }
}
customElements.define("as-modal-home-warning",AsModalHomeWarning)